import { v4 as uuidv4 } from "uuid";
import {
  TranslatableEntity,
  TranslatableEntityProps,
} from "../../shared/domain/TranslatableEntity";
import { LoyaltyTag, LoyaltyTagProps } from "./LoyaltyTag";

export interface CreateLoyaltyTagSectionProps extends TranslatableEntityProps {
  ticker: string;
  type: LoyaltyTagSectionType;
  tags: LoyaltyTagProps[];
}

export interface LoyaltyTagSectionProps extends CreateLoyaltyTagSectionProps {
  id: string;
  order: number;
}

export enum LoyaltyTagSectionType {
  PREFERENCE_SECTION = "PREFERENCE_SECTION",
}

export class LoyaltyTagSection extends TranslatableEntity {
  readonly id: string;
  readonly ticker: string;
  readonly type: LoyaltyTagSectionType;
  readonly order: number;
  readonly tags: LoyaltyTag[];

  private constructor(props: LoyaltyTagSectionProps) {
    super(props);
    this.id = props.id;
    this.ticker = props.ticker;
    this.type = props.type;
    this.order = props.order;
    this.tags = props.tags.map(LoyaltyTag.of);
  }

  static create(props: CreateLoyaltyTagSectionProps): LoyaltyTagSection {
    return new LoyaltyTagSection({
      id: uuidv4(),
      order: 0,
      ...props,
    });
  }

  static of(props: LoyaltyTagSectionProps): LoyaltyTagSection {
    return new LoyaltyTagSection(props);
  }
}
